/* Alien Fab Lab helper (2D mascot) - assets/alien-helper.js
   Markup: snippets/alien-helper.liquid. Targets: any element with data-help="<topic>".
   Pointer Events drag (mouse, touch, pen), drop-on-target help via elementsFromPoint,
   topics panel, Shopify Inbox hand-off, original idle dances, reduced-motion support. */
(function () {
  'use strict';
  var root = document.getElementById('ah');
  if (!root || window.__alienHelperInit) return;
  window.__alienHelperInit = true;
  var html = document.documentElement;

  try { init(); } catch (err) {
    // Something broke: give the page back its normal Inbox button and the plain fallback link.
    html.classList.remove('ah-ready');
    if (root) root.hidden = true;
    if (window.console) console.warn('[alien-helper] disabled:', err);
  }

  function init() {
    var cfg = {};
    try { cfg = JSON.parse(document.getElementById('ah-config').textContent) || {}; } catch (e) {}
    var TIPS = cfg.tips || {};
    var ORDER = (cfg.order || Object.keys(TIPS)).filter(function (k) { return TIPS[k]; });
    var CONTACT = cfg.contactUrl || '/pages/contact';
    var KEY = 'alienHelper.v1';

    var fig = root.querySelector('.ah__fig');
    var minBtn = root.querySelector('.ah__min');
    var img = root.querySelector('img');
    var bubble = document.getElementById('ah-bubble');
    var panel = document.getElementById('ah-panel');
    var tab = document.getElementById('ah-tab');
    var live = document.getElementById('ah-live');
    var fx = document.getElementById('ah-fx');
    var mqMobile = matchMedia('(max-width: 767.98px)');
    var mqReduce = matchMedia('(prefers-reduced-motion: reduce)');
    var coarse = matchMedia('(pointer: coarse)');

    // ---------- state ----------
    var state = { side: 'r', min: false };
    try { var s = JSON.parse(localStorage.getItem(KEY)); if (s) { state.side = s.side === 'l' ? 'l' : 'r'; state.min = !!s.min; } } catch (e) {}
    function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
    var pos = { x: 0, y: 0 };
    var mode = 'dock'; // 'dock' (resting, auto-placed) or 'free' (just dropped, showing a tip)
    function vw() { return html.clientWidth; }
    function vh() { return window.visualViewport ? Math.min(window.innerHeight, Math.round(visualViewport.height)) : window.innerHeight; }
    function dims() { return { w: root.offsetWidth || 160, h: root.offsetHeight || 240 }; }
    function clamp(v, a, b) { return Math.min(Math.max(v, a), Math.max(a, b)); }

    function setPos(x, y, glide, allowOff) {
      var d = dims();
      pos.x = allowOff ? x : clamp(x, 4, vw() - d.w - 4);
      pos.y = clamp(y, 4, vh() - d.h - 4);
      if (glide && !mqReduce.matches) {
        root.classList.add('is-gliding');
        clearTimeout(setPos.t); setPos.t = setTimeout(function () { root.classList.remove('is-gliding'); }, 550);
      }
      root.style.transform = 'translate3d(' + Math.round(pos.x) + 'px,' + Math.round(pos.y) + 'px,0)';
    }

    // ---------- resting spot: clear of the header, home bar and key controls ----------
    var AVOID = '[data-ah-avoid],.product-form__submit,.nse-quote__open,.shopify-payment-button,shopify-accelerated-checkout,' +
      '.nse-fin__field,.nse-fin select,.nse-fin input,.nse-fin__btn,.nse-fin__link,.nse-cmp-bar,.quantity,.cart-notification.active,' +
      'variant-selects .product-form__input,.product-form__input--pill,.cart__checkout-button,#checkout,.nse-searchbar__form,.contact button[type=submit],.nse-quote__submit,dialog[open]';
    function visibleRects(sel) {
      var out = [], H = vh(), W = vw();
      var list = document.querySelectorAll(sel);
      for (var i = 0; i < list.length; i++) {
        var el = list[i];
        if (isUI(el)) continue;
        var r = el.getBoundingClientRect();
        if (r.width < 2 || r.height < 2 || r.bottom < 0 || r.top > H || r.right < 0 || r.left > W) continue;
        out.push(r);
      }
      return out;
    }
    function headerBottom() {
      var b = 0, els = document.querySelectorAll('sticky-header,.section-header,.shopify-section-header-sticky,header.header');
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.height > 0 && r.top < vh() / 2 && r.bottom > b) b = r.bottom;
      }
      return Math.max(0, b);
    }
    function safeBottom() {
      var probe = document.getElementById('ah-safe');
      var sb = probe ? parseFloat(getComputedStyle(probe).paddingBottom) || 0 : 0;
      // iPhone home bar / collapsing toolbar: keep a margin even when env() reports 0
      return Math.max(sb, coarse.matches ? 28 : 16);
    }
    function overlaps(a, b, pad) {
      pad = pad || 0;
      return a.x < b.right + pad && a.x + a.w > b.left - pad && a.y < b.bottom + pad && a.y + a.h > b.top - pad;
    }
    // The art has transparent margins; use the body area for collision checks.
    function bodyBox(x, y) { var d = dims(); return { x: x + d.w * 0.18, y: y + d.h * 0.04, w: d.w * 0.64, h: d.h * 0.94 }; }
    function dockSpot() {
      var d = dims(), m = mqMobile.matches ? 10 : 16;
      var x = state.side === 'l' ? m : vw() - d.w - m;
      var top = headerBottom() + 8, bottom = vh() - d.h - safeBottom();
      var rects = visibleRects(AVOID);
      for (var y = bottom; y >= top; y -= 12) {
        var box = bodyBox(x, y), hit = false;
        for (var i = 0; i < rects.length; i++) if (overlaps(box, rects[i], 6)) { hit = true; break; }
        if (!hit) return { x: x, y: y, peek: false };
      }
      // No free band: tuck him into the side gutter so only a sliver shows.
      var edge = 0;
      rects.forEach(function (r) { edge = state.side === 'l' ? Math.max(edge, vw() - r.left) : Math.max(edge, r.right); });
      var gutter = state.side === 'l' ? vw() - edge : vw() - edge;
      var show = clamp(gutter - 2, 14, mqMobile.matches ? 30 : 48);
      var px = state.side === 'l' ? -(d.w * 0.82 - show) - d.w * 0.18 : vw() - d.w * 0.18 - show;
      return { x: px, y: bottom, peek: true };
    }
    var lastDock = null;
    function dock(glide) {
      if (mode !== 'dock' || drag || root.hidden) return;
      var s = dockSpot();
      if (lastDock && Math.abs(lastDock.x - s.x) < 2 && Math.abs(lastDock.y - s.y) < 2 && lastDock.peek === s.peek) return;
      lastDock = s;
      root.classList.toggle('is-peek', s.peek);
      setPos(s.x, s.y, glide, s.peek);
    }
    var dockQueued = false;
    function queueDock() {
      if (dockQueued) return; dockQueued = true;
      requestAnimationFrame(function () { dockQueued = false; dock(true); });
    }

    // ---------- target finding ----------
    function isUI(el) { return root.contains(el) || bubble.contains(el) || panel.contains(el) || tab.contains(el) || fx.contains(el); }
    function pick(x, y) {
      var els = document.elementsFromPoint(x, y);
      for (var i = 0; i < els.length; i++) {
        if (isUI(els[i])) continue;
        return els[i].closest('[data-help]'); // first real element under the point decides
      }
      return null;
    }
    function findTarget(x, y) {
      var hit = pick(x, y);
      if (hit && hit.getAttribute('data-help') !== 'page') return hit;
      var rings = [24, 48];
      for (var r = 0; r < rings.length; r++) for (var a = 0; a < 8; a++) {
        var t = pick(x + rings[r] * Math.cos(a * Math.PI / 4), y + rings[r] * Math.sin(a * Math.PI / 4));
        if (t && t.getAttribute('data-help') !== 'page') return t;
      }
      return hit;
    }
    var hlEl = null;
    function highlight(el) {
      if (hlEl === el) return;
      if (hlEl) hlEl.classList.remove('ah-hl');
      hlEl = el; if (el) el.classList.add('ah-hl');
    }
    function flash(el) { highlight(el); clearTimeout(flash.t); flash.t = setTimeout(function () { highlight(null); }, 2500); }
    function centerPt() { var d = dims(); return { x: pos.x + d.w / 2, y: pos.y + d.h / 2 }; }
    function topicOf(el) { var k = el && el.getAttribute('data-help'); return TIPS[k] ? k : 'page'; }

    // ---------- tip content (text only, never innerHTML from config) ----------
    function fillTip(container, key, targetPresent) {
      var tip = TIPS[key] || TIPS.page;
      var h = container.querySelector('[data-ah-title]'), p = container.querySelector('[data-ah-text]'), go = container.querySelector('[data-ah-go]');
      if (h) h.textContent = tip.title;
      p.textContent = tip.text;
      if (go) {
        if (!targetPresent && tip.href && tip.goLabel) { go.href = tip.href; go.textContent = tip.goLabel; go.hidden = false; }
        else go.hidden = true;
      }
    }

    // ---------- bubble placement (never on top of the target or key controls) ----------
    var bubbleTarget = null, bubbleScrollY = 0;
    function showBubble(key, target) {
      stopDance(); closePanel(false);
      fillTip(bubble, key, true);
      bubble.setAttribute('data-topic', key);
      bubble.hidden = false; bubbleTarget = target || null; bubbleScrollY = window.scrollY;
      positionBubble();
      bubble.classList.remove('is-in'); void bubble.offsetWidth; bubble.classList.add('is-in');
      fig.setAttribute('aria-expanded', 'true');
    }
    function area(a, b) {
      var w = Math.min(a.x + a.w, b.right) - Math.max(a.x, b.left), h = Math.min(a.y + a.h, b.bottom) - Math.max(a.y, b.top);
      return w > 0 && h > 0 ? w * h : 0;
    }
    function positionBubble() {
      if (bubble.hidden) return;
      var d = dims(), bw = bubble.offsetWidth, bh = bubble.offsetHeight, g = mqMobile.matches ? 4 : 12, W = vw(), H = vh();
      var top = headerBottom() + 8, bottom = H - safeBottom();
      var me = { left: pos.x + d.w * 0.15, right: pos.x + d.w * 0.85, top: pos.y, bottom: pos.y + d.h };
      var cands = [
        { side: 'left', x: pos.x - bw - g, y: pos.y + d.h * 0.04 },
        { side: 'right', x: pos.x + d.w + g, y: pos.y + d.h * 0.04 },
        { side: 'top', x: pos.x + d.w / 2 - bw / 2, y: pos.y - bh - g },
        { side: 'bottom', x: pos.x + d.w / 2 - bw / 2, y: pos.y + d.h + g },
        { side: 'left', x: pos.x - bw - g, y: pos.y + d.h - bh },
        { side: 'right', x: pos.x + d.w + g, y: pos.y + d.h - bh },
        { side: 'left', x: pos.x - bw - g, y: pos.y - bh / 2 },
        { side: 'right', x: pos.x + d.w + g, y: pos.y - bh / 2 },
        { side: 'left', x: pos.x - bw - g, y: pos.y - bh + 30 },
        { side: 'right', x: pos.x + d.w + g, y: pos.y - bh + 30 },
        { side: 'band', x: (W - bw) / 2, y: top },
        { side: 'band', x: (W - bw) / 2, y: bottom - bh },
        { side: 'band', x: 8, y: top },
        { side: 'band', x: W - bw - 8, y: top },
        { side: 'band', x: 8, y: bottom - bh },
        { side: 'band', x: W - bw - 8, y: bottom - bh }
      ];
      var tr = bubbleTarget ? bubbleTarget.getBoundingClientRect() : null;
      var avoid = visibleRects(AVOID);
      var best = null;
      cands.forEach(function (c, i) {
        var raw = { x: c.x, y: c.y };
        c.x = clamp(c.x, 8, W - bw - 8); c.y = clamp(c.y, top, bottom - bh);
        var box = { x: c.x, y: c.y, w: bw, h: bh };
        // prefer the natural spot next to him, but never sit on a control (APR select, Add to cart, ...)
        var score = i * 10 + Math.abs(raw.x - c.x) + Math.abs(raw.y - c.y);
        var mine = area(box, me); if (mine) score += 20000 + mine;
        avoid.forEach(function (r) { var o = area(box, { left: r.left - 6, right: r.right + 6, top: r.top - 6, bottom: r.bottom + 6 }); if (o) score += 100000 + o * 4; });
        if (tr && bubbleTarget.getAttribute('data-help') !== 'page') score += area(box, tr) * 0.5;
        if (!best || score < best.score) { best = c; best.score = score; }
      });
      var side = best.side === 'band' ? (best.y + bh < pos.y ? 'top' : 'none') : best.side;
      bubble.setAttribute('data-side', side);
      var t = 'translate(' + Math.round(best.x) + 'px,' + Math.round(best.y) + 'px)';
      bubble.style.setProperty('--t', t);
      bubble.style.transform = t;
    }
    function closeBubble(refocus) {
      if (bubble.hidden) return;
      bubble.hidden = true; bubbleTarget = null; fig.setAttribute('aria-expanded', 'false');
      goHome();
      if (refocus) fig.focus({ preventScroll: true });
    }
    function goHome() {
      if (mode === 'free') {
        var d = dims();
        state.side = pos.x + d.w / 2 < vw() / 2 ? 'l' : 'r'; save();
      }
      mode = 'dock'; lastDock = null; dock(true);
    }

    // ---------- topics panel ----------
    var topicsUl = panel.querySelector('.ah-topics');
    function presentTarget(k) {
      var list = document.querySelectorAll('[data-help="' + k + '"]');
      for (var i = 0; i < list.length; i++) { var r = list[i].getBoundingClientRect(); if (r.width > 0 && r.height > 0) return list[i]; }
      return null;
    }
    function buildTopics() {
      topicsUl.textContent = '';
      ORDER.forEach(function (k) {
        if (k === 'page') return;
        var li = document.createElement('li'), b = document.createElement('button');
        b.type = 'button'; b.setAttribute('data-topic', k); b.setAttribute('aria-pressed', 'false');
        b.textContent = TIPS[k].label || TIPS[k].title;
        li.appendChild(b); topicsUl.appendChild(li);
      });
    }
    topicsUl.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-topic]'); if (!b) return;
      var k = b.getAttribute('data-topic');
      var bs = topicsUl.querySelectorAll('button');
      for (var i = 0; i < bs.length; i++) bs[i].setAttribute('aria-pressed', String(bs[i] === b));
      var target = presentTarget(k);
      fillTip(panel, k, !!target);
      if (target) {
        var r = target.getBoundingClientRect(), H = vh();
        var panelTop = panel.getBoundingClientRect().top;
        if (r.top < headerBottom() || r.top > panelTop - 40) {
          var y = window.scrollY + r.top - Math.max(90, H * 0.12);
          window.scrollTo({ top: Math.max(0, y), behavior: mqReduce.matches ? 'auto' : 'smooth' });
        }
        flash(target);
      }
    });
    function openPanel() {
      stopDance(); bubble.hidden = true; bubbleTarget = null;
      buildTopics();
      fillTip(panel, 'page', true);
      panel.hidden = false; fig.setAttribute('aria-expanded', 'true');
      var first = topicsUl.querySelector('button'); if (first) first.focus({ preventScroll: true });
    }
    function closePanel(refocus) {
      if (panel.hidden) return;
      panel.hidden = true; fig.setAttribute('aria-expanded', 'false');
      if (refocus) fig.focus({ preventScroll: true });
    }

    // ---------- Shopify Inbox hand-off ----------
    // Current Inbox embed is <shopify-chat> (public show()/close() methods, ::part(activator)).
    // Older embeds used <inbox-online-store-chat>; we click its launcher. Otherwise: contact page.
    function tryOpenInbox() {
      var c = document.querySelector('shopify-chat');
      if (c && typeof c.show === 'function') { c.show(); return true; }
      var old = document.querySelector('inbox-online-store-chat');
      var btn = old && old.shadowRoot && old.shadowRoot.querySelector('button');
      if (btn) { btn.click(); return true; }
      return false;
    }
    function talk() {
      closePanel(false); bubble.hidden = true; bubbleTarget = null; fig.setAttribute('aria-expanded', 'false');
      goHome();
      if (tryOpenInbox()) { announce('Opening chat.'); return; }
      // The chat script loads late; give it a moment before falling back to the contact page.
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (tryOpenInbox()) { clearInterval(iv); announce('Opening chat.'); }
        else if (tries > 12) { clearInterval(iv); window.location.href = CONTACT; }
      }, 200);
    }
    function onAct(e, container) {
      if (e.target.closest('.ah-x')) return container === bubble ? closeBubble(true) : (closePanel(true), goHome());
      var act = e.target.closest('[data-act]'); if (!act) return;
      var a = act.getAttribute('data-act');
      if (a === 'talk') talk();
      else if (a === 'topics') openPanel();
      else if (a === 'minimize') setMin(true);
      else if (a === 'dance') { closePanel(false); goHome(); setTimeout(function () { danceNow(); }, 250); }
    }
    bubble.addEventListener('click', function (e) { onAct(e, bubble); });
    panel.addEventListener('click', function (e) { onAct(e, panel); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!panel.hidden) { closePanel(true); goHome(); } else if (!bubble.hidden) closeBubble(true);
    });
    document.addEventListener('pointerdown', function (e) {
      if (!isUI(e.target)) { if (!bubble.hidden) closeBubble(false); if (!panel.hidden) { closePanel(false); goHome(); } }
    });

    // ---------- open help where he stands ----------
    function helpHere() {
      if (mqMobile.matches || mode === 'dock') return openPanel();
      var c = centerPt(), t = findTarget(c.x, c.y);
      if (t) flash(t);
      showBubble(topicOf(t), t);
    }

    // ---------- drag (Pointer Events; touch-action:none on the figure only) ----------
    var drag = null, rafPending = false, lastPt = null, ghostUntil = 0, ghostX = 0, ghostY = 0;
    document.addEventListener('click', function (e) {
      if (Date.now() < ghostUntil && Math.abs(e.clientX - ghostX) < 30 && Math.abs(e.clientY - ghostY) < 30) {
        ghostUntil = 0; e.preventDefault(); e.stopPropagation();
      }
    }, true);
    function startHeld() {
      stopDance();
      mode = 'free';
      root.classList.remove('is-dropped', 'is-peek', 'is-gliding'); root.classList.add('is-held');
      bubble.hidden = true; bubbleTarget = null; closePanel(false);
      html.style.webkitUserSelect = 'none'; html.style.userSelect = 'none';
    }
    function endHeld() {
      root.classList.remove('is-held');
      html.style.webkitUserSelect = ''; html.style.userSelect = '';
      if (!mqReduce.matches) {
        root.classList.add('is-dropped');
        clearTimeout(endHeld.t); endHeld.t = setTimeout(function () { root.classList.remove('is-dropped'); }, 520);
      }
    }
    fig.addEventListener('pointerdown', function (e) {
      if ((e.pointerType === 'mouse' && e.button !== 0) || drag) return;
      e.preventDefault(); // no text selection, native image drag or iOS callout
      // grab offset relative to where he is drawn now (he may be tucked into the gutter)
      drag = { id: e.pointerId, sx: e.clientX, sy: e.clientY, ox: e.clientX - pos.x, oy: e.clientY - pos.y, armed: false, t0: Date.now() };
      try { fig.setPointerCapture(e.pointerId); } catch (_) {}
    });
    fig.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dist = Math.hypot(e.clientX - drag.sx, e.clientY - drag.sy);
      if (!drag.armed) {
        if (dist < 6) return;
        drag.armed = true; startHeld();
        if (root.classList.contains('is-peek') || pos.x < 0 || pos.x > vw() - dims().w) { drag.ox = dims().w / 2; drag.oy = dims().h * 0.4; }
      }
      setPos(e.clientX - drag.ox, e.clientY - drag.oy);
      lastPt = { x: e.clientX, y: e.clientY };
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(function () { rafPending = false; if (drag && lastPt) highlight(findTarget(lastPt.x, lastPt.y)); });
      }
    });
    function finish(e, cancelled) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag; drag = null;
      try { fig.releasePointerCapture(e.pointerId); } catch (_) {}
      if (d.armed) {
        endHeld();
        if (cancelled) { highlight(null); goHome(); return; }
        dropAt(e.clientX, e.clientY);
      } else if (!cancelled) {
        // A tap or click. The browser's own click follows pointerup at the same spot, which would land
        // on the panel that just opened (a "ghost click" picking a topic). Swallow it.
        ghostUntil = Date.now() + 600; ghostX = e.clientX; ghostY = e.clientY;
        helpHere();
      }
    }
    fig.addEventListener('pointerup', function (e) { finish(e, false); });
    fig.addEventListener('pointercancel', function (e) { finish(e, true); });
    // Belt and braces for iOS: never let a touch that starts on him scroll the page.
    fig.addEventListener('touchmove', function (e) { if (e.cancelable) e.preventDefault(); }, { passive: false });
    fig.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    fig.addEventListener('dragstart', function (e) { e.preventDefault(); });

    function dropAt(x, y) {
      var t = findTarget(x, y);
      if (!t) {
        highlight(null); bubble.hidden = true;
        announce('Nothing to help with there. Heading back to my spot.');
        goHome();
        return;
      }
      flash(t);
      if (mqMobile.matches) {
        // phones: step to the nearest edge (same height) so the tip fits beside him, not on top of him
        var d = dims(), left = pos.x + d.w / 2 < vw() / 2;
        setPos(left ? 4 : vw() - d.w - 4, pos.y, true);
        bubble.style.width = Math.min(290, vw() - d.w - 24) + 'px';
      } else bubble.style.width = '';
      showBubble(topicOf(t), t);
      announce((TIPS[topicOf(t)] || TIPS.page).title);
    }

    // ---------- keyboard ----------
    var announceT = null;
    function announce(msg) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); }
    fig.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'Enter' || k === ' ') { e.preventDefault(); helpHere(); return; }
      var step = e.shiftKey ? 48 : 12;
      var dv = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] }[k];
      if (!dv) return;
      e.preventDefault();
      stopDance();
      if (mode === 'dock') { mode = 'free'; root.classList.remove('is-peek'); }
      bubble.hidden = true; bubbleTarget = null; fig.setAttribute('aria-expanded', 'false');
      setPos(pos.x + dv[0], pos.y + dv[1]);
      var c = centerPt(), t = findTarget(c.x, c.y); highlight(t);
      clearTimeout(announceT);
      announceT = setTimeout(function () {
        var name = t && t.getAttribute('data-help') !== 'page' ? (TIPS[topicOf(t)] || TIPS.page).title : 'nothing in particular';
        announce('Helper is over ' + name + '. Press Enter for help.');
      }, 350);
    });

    // ---------- minimize ----------
    function setMin(on) {
      state.min = on; save();
      root.hidden = on; tab.hidden = !on;
      bubble.hidden = true; bubbleTarget = null; closePanel(false);
      if (on) tab.focus({ preventScroll: true });
      else { mode = 'dock'; lastDock = null; loadArt(); dock(false); fig.focus({ preventScroll: true }); }
    }
    if (minBtn) minBtn.addEventListener('click', function () { setMin(true); });
    tab.addEventListener('click', function () { setMin(false); });

    // ---------- step aside for drawers, menus, modals and the chat window ----------
    function somethingOpen() {
      var b = document.body;
      if (/\boverflow-hidden/.test(b.className)) return true;
      if (document.querySelector('dialog[open]:not(.ah-ignore), .drawer.active, details[open] > .menu-drawer, details-modal details[open]')) return true;
      var c = document.querySelector('shopify-chat');
      return !!(c && c.open === true);
    }
    function checkAway() {
      var away = somethingOpen();
      root.classList.toggle('is-away', away); tab.classList.toggle('is-away', away);
      if (away) { bubble.hidden = true; bubbleTarget = null; closePanel(false); stopDance(); }
    }

    // ---------- idle life ----------
    function every(cls, min, max, dur) {
      function tick() {
        if (!mqReduce.matches && !root.hidden && !root.classList.contains('is-held') && !(cls === 'is-tilting' && dance)) {
          root.classList.add(cls); setTimeout(function () { root.classList.remove(cls); }, dur);
        }
        setTimeout(tick, min + Math.random() * (max - min));
      }
      setTimeout(tick, min + Math.random() * (max - min));
    }

    // ---------- idle dances (original moves: shuffle, hop-and-spin, victory bounce) ----------
    var DANCES = {
      shuffle: { ms: 2400, label: 'side shuffle', fx: [[300, 'dust', 'l'], [900, 'dust', 'r'], [1500, 'dust', 'l'], [2100, 'dust', 'r']] },
      hopspin: { ms: 1500, label: 'hop and spin', fx: [[240, 'dust', 'both'], [1080, 'dust', 'both']] },
      victory: { ms: 2100, label: 'victory bounce', fx: [[460, 'spark'], [970, 'spark'], [1470, 'spark']] }
    };
    var NAMES = Object.keys(DANCES);
    var IDLE_MS = 8000, MAX_AUTO = cfg.maxAutoDances == null ? 3 : cfg.maxAutoDances;
    var dance = null, lastDance = null, demoIdx = 0, lastActive = Date.now(), nextDanceAt = 0;
    var autoCount = 0; try { autoCount = +sessionStorage.getItem(KEY + '.dances') || 0; } catch (e) {}
    function canDance() {
      return cfg.dances !== false && !mqReduce.matches && !root.hidden && !drag && !root.classList.contains('is-held') &&
        !root.classList.contains('is-peek') && !root.classList.contains('is-away') && bubble.hidden && panel.hidden && document.visibilityState === 'visible';
    }
    function spawn(kind, opt) {
      var d = dims(), m = mqMobile.matches ? 0.55 : 1, R = Math.random;
      function add(cls, x, y, vars, text) {
        var s = document.createElement('span'); s.className = 'ah-p ' + cls;
        s.style.left = Math.round(x) + 'px'; s.style.top = Math.round(y) + 'px';
        for (var k in vars) s.style.setProperty(k, vars[k]);
        if (text) s.textContent = text;
        s.addEventListener('animationend', function () { s.remove(); });
        fx.appendChild(s);
      }
      if (kind === 'note') {
        add('ah-p--note', pos.x + d.w * (0.2 + R() * 0.6), pos.y + d.h * 0.02,
          { '--dx': (R() * 44 - 22) * m + 'px', '--dy': -(60 + R() * 40) * m + 'px', '--rot': (R() * 50 - 25) + 'deg' }, R() < 0.5 ? '\u266A' : '\u266B');
      } else if (kind === 'dust') {
        var xs = opt === 'l' ? [0.35] : opt === 'r' ? [0.65] : [0.3, 0.7];
        xs.forEach(function (f) {
          for (var i = 0; i < 3; i++) add('ah-p--dust', pos.x + d.w * f + (R() * 14 - 7) * m, pos.y + d.h - 6,
            { '--dx': (R() * 26 - 13) * m + 'px', '--s': (0.6 + R() * 0.8) * (mqMobile.matches ? 0.6 : 1) });
        });
      } else if (kind === 'spark') {
        var cx = pos.x + d.w / 2, cy = pos.y + d.h * 0.28, n = mqMobile.matches ? 6 : 10;
        for (var i = 0; i < n; i++) {
          var a = i / n * Math.PI * 2 + R() * 0.3, r = (55 + R() * 35) * m;
          add('ah-p--spark' + (i % 2 ? ' is-cy' : ''), cx, cy, { '--dx': Math.cos(a) * r + 'px', '--dy': Math.sin(a) * r + 'px' });
        }
      }
    }
    function startDance(name) {
      if (!canDance() || !DANCES[name]) return false;
      stopDance();
      var d = DANCES[name];
      root.classList.remove('is-tilting');
      root.classList.add('is-dancing', 'dance-' + name);
      var timers = d.fx.map(function (f) { return setTimeout(function () { spawn(f[1], f[2]); }, f[0]); });
      var gap = mqMobile.matches ? 700 : 420;
      for (var t = 120; t < d.ms - 200; t += gap) timers.push(setTimeout(function () { spawn('note'); }, t));
      timers.push(setTimeout(function () { stopDance(true); }, d.ms + 40));
      dance = { name: name, timers: timers }; lastDance = name;
      return true;
    }
    function stopDance(natural) {
      if (!dance) return;
      dance.timers.forEach(clearTimeout);
      root.classList.remove('is-dancing');
      NAMES.forEach(function (n) { root.classList.remove('dance-' + n); });
      if (!natural) fx.textContent = '';
      dance = null;
      nextDanceAt = Date.now() + 10000 + Math.random() * 5000;
    }
    function danceNow(name) {
      if (mqReduce.matches) { announce('Dancing is off because reduced motion is on.'); return false; }
      name = name || NAMES[demoIdx++ % NAMES.length];
      var ok = startDance(name);
      if (ok) announce('The helper is doing the ' + DANCES[name].label + '.');
      return ok;
    }
    ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (type) {
      window.addEventListener(type, function () { lastActive = Date.now(); if (type !== 'wheel') stopDance(); }, { capture: true, passive: true });
    });

    // ---------- art: lazy, after the page has loaded ----------
    var artLoaded = false;
    function loadArt() {
      if (artLoaded || state.min) return; artLoaded = true;
      var srcs = root.querySelectorAll('source[data-srcset]');
      for (var i = 0; i < srcs.length; i++) srcs[i].srcset = srcs[i].getAttribute('data-srcset');
      if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
      img.src = img.getAttribute('data-src');
    }

    // ---------- go ----------
    html.classList.add('ah-ready');
    root.hidden = !!state.min; tab.hidden = !state.min;
    dock(false);
    function idle(fn) { (window.requestIdleCallback || function (f) { return setTimeout(f, 200); })(fn, { timeout: 2500 }); }
    if (document.readyState === 'complete') idle(loadArt); else window.addEventListener('load', function () { idle(loadArt); });
    every('is-blinking', 2500, 6000, 220);
    every('is-tilting', 7000, 13000, 1450);

    var lastScrollY = window.scrollY;
    window.addEventListener('scroll', function () {
      if (!bubble.hidden && Math.abs(window.scrollY - bubbleScrollY) > 80) closeBubble(false);
      if (Math.abs(window.scrollY - lastScrollY) > 4) { lastScrollY = window.scrollY; queueDock(); }
    }, { passive: true });
    window.addEventListener('resize', function () { lastDock = null; queueDock(); positionBubble(); });
    if (window.visualViewport) visualViewport.addEventListener('resize', function () { lastDock = null; queueDock(); });
    mqMobile.addEventListener && mqMobile.addEventListener('change', function () { bubble.hidden = true; closePanel(false); mode = 'dock'; lastDock = null; dock(false); });
    setInterval(function () {
      checkAway();
      if (!drag && mode === 'dock') dock(true); // layout can change (sticky bars, notifications, lazy images)
      if (dance || cfg.dances === false) return;
      var now = Date.now();
      if (now - lastActive < IDLE_MS || now < nextDanceAt || autoCount >= MAX_AUTO || !canDance()) return;
      var pool = NAMES.filter(function (n) { return n !== lastDance; });
      if (startDance(pool[Math.floor(Math.random() * pool.length)])) {
        autoCount++; try { sessionStorage.setItem(KEY + '.dances', autoCount); } catch (e) {}
      }
    }, 500);

    // Small public API (also used by QA scripts): AlienHelper.dance('victory'), .open(), .talk()
    window.AlienHelper = {
      dance: function (n) { return danceNow(n); }, stopDance: function () { stopDance(); }, isDancing: function () { return !!dance; },
      open: openPanel, close: function () { closeBubble(false); closePanel(false); goHome(); }, talk: talk,
      findTarget: findTarget, state: function () { return { x: pos.x, y: pos.y, mode: mode, side: state.side, min: state.min, peek: root.classList.contains('is-peek') }; },
      dances: NAMES.slice()
    };
  }
})();
